import { HttpConfig } from './types';

export const DefaultHttpConfig: HttpConfig<any> = {
  retryMax: 3,
};
